import { createMockableHook } from '@repo/common/utils/createMockableHook';
import { useSuspenseQuery } from '@tanstack/react-query';
import { metricsQueryKeyFactory } from '.';
import { apiClient, getEndpoints } from '../../common';
import type { IMetric } from '../../types';

export async function fetchMetric(id: string): Promise<IMetric> {
	const url = getEndpoints(metricsQueryKeyFactory.namespace).byPath([id]);
	const { data } = await apiClient.get<IMetric>(url);
	return data;
}

function useGetOrCreateMetricInternal({ id, ...data }: Partial<IMetric>) {
	return useSuspenseQuery({
		queryKey: [...metricsQueryKeyFactory.all(), 'get_or_create', id],
		queryFn: async () => {
			const url = getEndpoints(metricsQueryKeyFactory.namespace).root();
			const { data: metric } = await apiClient.post<IMetric>(url, {
				id,
				...data,
			});
			return metric;
		},
	});
}

export const [useGetOrCreateMetric, MockUseGetOrCreateMetric] =
	createMockableHook(useGetOrCreateMetricInternal);
